import React, { useEffect } from 'react';
import { AppLayoutTypes } from '@types';
import classNames from 'classnames';

import GlobalCtx from '@components/globalContext';

// TODO: This would be a good pattern for a HOC - I keep using it everywhere
const LayoutType = (): JSX.Element => {
  const { app, setApp } = React.useContext(GlobalCtx);
  const { layout: layoutViaCtx } = app;
  const [layout, setLayout] = React.useState<AppLayoutTypes>(layoutViaCtx);
  const isSideBySide = layout === 'SIDE_BY_SIDE';

  const labelClasses = classNames('text-center cursor-pointer', isSideBySide ? '' : 'active');

  const updateDisplayType = (type: AppLayoutTypes) => {
    setApp({
      ...app,
      layout: type,
    });
  };

  useEffect(() => {
    if (layout !== layoutViaCtx) {
      setLayout(layoutViaCtx);
    }
  }, [layoutViaCtx]);
  return (
    <div className="grid grid-cols-2 mt-4">
      <label className={labelClasses}>
        <input
          type="radio"
          value={'MODIFIED'}
          onChange={() => updateDisplayType('MODIFIED')}
          checked={!isSideBySide}
        />
        <span className="ml-2">Modified View</span>
      </label>
      <label className={labelClasses}>
        <input
          type="radio"
          value={'SIDE_BY_SIDE'}
          onChange={() => {
            updateDisplayType('SIDE_BY_SIDE');
          }}
          checked={isSideBySide}
        />
        <span className="ml-2">Side By Side View</span>
      </label>
    </div>
  );
};

export default LayoutType;
